import { render, staticRenderFns } from "./MediaUpload.vue?vue&type=template&id=c2d4dfea&scoped=true&"
import script from "./MediaUpload.vue?vue&type=script&lang=js&"
export * from "./MediaUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d4dfea",
  null
  
)

export default component.exports